export default {
  trainer: 'Trainer',
  athlete: 'Athlete',
  scout: 'Scout',
  casual: 'Casual',
};
